import { NavLink, useNavigate } from "react-router-dom";
import { removeToken } from "../../../utils/Auth";
import "./MenuAdmin.css";

const MenuAdmin = () => {
    const navigate = useNavigate();

    const logout = () => {
        removeToken();
        navigate("/admin-oks/login");
    };

    return (
        <div className="menu-admin">
            <NavLink to="/admin-oks/orders">Orders</NavLink>
            <NavLink to="/admin-oks/categories">Categories</NavLink>
            <NavLink to="/admin-oks/items">Items</NavLink>

            <button onClick={logout}>Logout</button>
        </div>
    );
};

export default MenuAdmin;
